import axios from 'axios';
import ApiService from "@services/api.service";
import errorResponseHandler from '@services/api.error.service';

export default {
    install(Vue, options) {

        const optionsDefaults = {}

        // Merge options argument into options defaults
        options = {
            ...optionsDefaults,
            ...options
        }

        window.axios = axios;

        // Set the base URL of the API
        ApiService.init(process.env.MIX_VUE_APP_ROOT_API);

        // Set default header
        ApiService.setDefaultHeaders();

        // apply interceptor on request
        axios.interceptors.request.use(function (config) {
            // Do something before request is sent
            Vue.prototype.$Progress.start();
            return config;
        }, function (error) {
            // Do something with request error
            return Promise.reject(error);
        });

        // apply interceptor on response
        axios.interceptors.response.use(
            response => {
                Vue.prototype.$Progress.finish();
                return response
            },
            errorResponseHandler
        );

    }
}
